import axios from "axios";
import { API_BASE_URL } from "../../utilities/constants";

export default axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Authorization: process.env.REACT_APP_AUTHORIZED_ACCESS_SECRET,
    "Content-type": "application/json",
  },
});
